import React from 'react';
import { AsoScenarioMinLayerType } from '@ydistri/api-sdk';
import AsoLayerDefinition from './AsoLayerDefinition';
import { TwoColumnContainer } from '../components/TwoColumnContainer';
import { Flex, Row, Section, Title } from '@ydistri/ds';
import AsoTooltip from '../AsoTooltip';

export interface AsoLayersProps {
  asoScenarioId: number;
  scopeId?: number;
  variant: 'global' | 'scope';
}

const AsoLayers: React.FC<AsoLayersProps> = ({ asoScenarioId, scopeId, variant }) => {
  if (variant === 'global') {
    return (
      <Section header="Global min layers" collapsible>
        <TwoColumnContainer>
          <Row $alignItems="center" $gap="1rem">
            <Title>Source: </Title>
            <AsoTooltip tooltipKey="globalSourceMinLayer" />
            <Flex $flexGrow={1}>
              <AsoLayerDefinition
                asoScenarioId={asoScenarioId}
                layerTypeId={AsoScenarioMinLayerType.Source}
                scopeId={scopeId}
              />
            </Flex>
          </Row>
          <Row $alignItems="center" $gap="1rem">
            <Title>Target: </Title>
            <AsoTooltip tooltipKey="globalTargetMinLayer" />
            <Flex $flexGrow={1}>
              <AsoLayerDefinition
                asoScenarioId={asoScenarioId}
                layerTypeId={AsoScenarioMinLayerType.Target}
                scopeId={scopeId}
              />
            </Flex>
          </Row>
        </TwoColumnContainer>
      </Section>
    );
  }

  return (
    <TwoColumnContainer>
      <Row $alignItems="center" $gap="1rem">
        <Title>Source Min. Layers: </Title>
        <AsoTooltip tooltipKey="scopeSourceMinLayer" />
        <Flex $flexGrow={1}>
          <AsoLayerDefinition
            asoScenarioId={asoScenarioId}
            layerTypeId={AsoScenarioMinLayerType.Source}
            scopeId={scopeId}
          />
        </Flex>
      </Row>
      <Row $alignItems="center" $gap="1rem">
        <Title>Target Min. Layers: </Title>
        <AsoTooltip tooltipKey="scopeTargetMinLayer" />
        <Flex $flexGrow={1}>
          <AsoLayerDefinition
            asoScenarioId={asoScenarioId}
            layerTypeId={AsoScenarioMinLayerType.Target}
            scopeId={scopeId}
          />
        </Flex>
      </Row>
    </TwoColumnContainer>
  );
};

export default AsoLayers;
